import {User}									from '../user/interface';
import {ApiOrderAssignState, ApiOrderState,
	ApiOrderLimitedState}						from './interface';

import * as API									from '../../ressources/API';


export default {
	getOrdersApi: async (user: User) => {
		const response = await API.getOrder(user);
		if (!response || !response.status)
			return [];
		return response.data;
	},
	getOrderLimitedApi: async (data: ApiOrderLimitedState) => {
		const response = await API.getOrderLimited(data.idOrder, data.orderToken);
		if (!response || !response.status)
			return [];
		return response.data;
	},
	putOrderAssignApi: async (data: ApiOrderAssignState) => {
		if (!data.idOrder)
			return null;

		const response = await API.putOrderAssignDevice(data.idOrder, data.indexAddress, data.indexDevice, data.indexAssign, data.idUser, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	postOrderApi: async (data: ApiOrderState) => {
		data.data.hubspot = true;

		const response = await API.postOrder(data.data, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	}
};
